<template>
  <div class="main__layout">
    <transition name="slide">
    <factory-list v-show="sidebar || windowWidth > 1024"></factory-list>
    </transition>
    <feature-factory></feature-factory>
    <rep-group></rep-group>
    <i v-if="windowWidth < 1024" @click="toggleSidebar" class="toggle material-icons">{{sidebar ? 'close' : 'menu'}}</i>
  </div>
</template>

<script>
import {store} from '@/store'
import FactoryList from '@/components/mainpage/FactoryList'
import FeatureFactory from '@/components/mainpage/FeatureFactory'
import RepGroup from '@/components/mainpage/RepGroup'
export default {
  name: 'MainPage',
  data: function(){
    return {
      windowWidth: 0
    }
  },
  computed: {
    sidebar: function(){
      return store.state.sidebar
    }
  },
  components: {
    FactoryList,
    FeatureFactory,
    RepGroup
  },
  methods: {
    toggleSidebar: function(){
      console.log('toggle')
      store.commit('togglesidebar')
    },
    getWindowWidth(event) {
      this.windowWidth = document.documentElement.clientWidth;
    }
  },
  mounted: function() {
    store.dispatch('getFactories')
    store.dispatch('getRepGroups')
    this.$nextTick(function() {
      window.addEventListener('resize', this.getWindowWidth);
      this.getWindowWidth()
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getWindowWidth);
  } 
}
</script>

<style scoped lang="less">
.shadow {
  box-shadow: 0px 2px 12px 0px rgba(0,0,0,0.25);
}
.main__layout {
  padding: 60px 0px 80px 250px;
}
@media screen and (max-width: 1024px){
  .main__layout {
    padding: 60px 0px 80px 0px;
  }
  .toggle {
    display: block;
    position: fixed;
    bottom: 24px;
    right: 24px;
    background: #1882e6;
    color: white;
    border: solid 2px;
    border-radius: 50%;
    z-index: 3500;
    cursor: pointer;
    padding: 12px;
    &:extend(.shadow);
  }
}
.slide-enter-active, .slide-leave-active {
  transition: all .25s ease-out;
}
.slide-enter, .slide-leave-to /* .fade-leave-active below version 2.1.8 */ {
  transform: translateX(-250px);
  opacity: 0.5;
}
</style>



// WEBPACK FOOTER //
// src/components/mainpage/MainPage.vue